import $ from 'jquery';
import Backbone from 'backbone';
import '../vendors/global-jquery';
import '../vendors/global-underscore';
import '../vendors/global-backbone';
import '../vendors/global-js-cookies';
import '../common/others/global-configuration.js';
import '../common/others/global-SharedDispatcher';
import 'nanoscroller';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import '../vendors/jquery.popinManager.js';
import '../vendors/jquery.shutter.js';
import '../../../Legacy/Js/jqueryPlugins/jquery.radio.js';
import '../common/others/AppCore.js';
import '../common/others/jquery.validate.unobtrusive.extensions.js';
import '../common/others/searchAutoCompleteSwitch';
import '../account/entries.old.js';
import '../common/others/global-hl-instantiateService.js';
import '../nav/entries.js';
import '../account/entries.js';
import '../../../Legacy/Js/myAccount.js';
import '../../../Legacy/Js/fly.js';
import '../../../Legacy/Js/showRegulPopin.js';
import '../../../Legacy/Js/guides/guide.tabs.js';
import AlertingView from '../account/views/alerts/AlertingView';
import 'component?js-registration-form';
import 'component?js-dashboard-page';
import 'component?js-addresses-form';
import 'component?js-bank-page';
import 'component?js-yearFilterForm';
import 'component?js-checkOptional';
import 'component?js-preferences-page';
import 'component?js-resetpassword-form';
import 'component?js-findquoteinvoice-form';
import 'component?js-CheckoutPage';
import 'component?js-iframe-resizer';
import 'component?js-LazyImage';
import 'component?js-wishlist-button';
import SharedDispatcher from '../common/others/SharedDispatcher';
import '../account/adresses/OrderAddressDetailChangeStoreClosed';
import '../account/common/sidebar';

Backbone.emulateHTTP = true;

// Add a CSS helper class to account pages
$('body').addClass('account');

const $maMain = $('.ma-Main');
if ($maMain.length) {
  new AlertingView({ el: $maMain });
}

const $emailRecover = $('.js-EmailRecover');
if ($emailRecover.length) {
  if (sessionStorage.getItem('emailRecover')) {
    $emailRecover.val(sessionStorage.getItem('emailRecover'));
    sessionStorage.removeItem('emailRecover');
  }
}

// Mention légale push TR
$('body').on('click', '.f-js-legalNotice-mentionTitle', function () {
  $(this).toggleClass('isActive').siblings('.f-js-legalNotice-mentionContent').toggleClass('isActive');
});
// Tacit agreement renewal on "Ma carte" page
$('.js-tacitAgreement').on('click', '.js-query', function (e) {
  e.preventDefault();
  window.digitalData?.events.push({
    eventInfo: {
      eventAction: 'account_cancelrenewfnacplus',
      type: 'intent',
      timeStamp: new Date().toJSON(),
    },
  });
  const url = $(this).data('url');
  callUrl(url, ReloadPage);
  disableButton();
});

function callUrl(url, callback) {
  $.ajax({
    type: 'POST',
    url: url,
    success: function (data) {
      if (data !== '') {
        callback();
        //$(".js-tacitAgreement").html(data);
      }
    },
    error: function () {
      SharedDispatcher.trigger('flashmessage:show');
    },
  });
}

function ReloadPage() {
  location.reload();
}

function disableButton() {
  $('.js-renewal-button').attr('disabled', 'disabled');
}
